const style = {
  fontFamily: "Pretendard",
  fontSize: 17,
  fontWeight: 600
};

export function AnnouncementText(props) {
  return (<>
    <span style={ style }>{ props.text }</span>
  </>);
}
